document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.workflow-section' ).forEach( ( section ) => {
		const dataEl = section.querySelector( '.workflow-section__data' );
		if ( ! dataEl ) return;

		let steps;
		try {
			steps = JSON.parse( dataEl.textContent );
		} catch ( e ) {
			return;
		}

		const indicators = section.querySelectorAll( '.workflow-section__indicator' );
		const paginationDots = section.querySelectorAll( '.workflow-section__pagination-dot' );
		const slots = section.querySelectorAll( '.workflow-section__detail-inner' );
		const detailEl = section.querySelector( '.workflow-section__detail' );
		const prevBtn = section.querySelector( '.workflow-section__nav-prev' );
		const nextBtn = section.querySelector( '.workflow-section__nav-next' );
		let activeIndex = 0;

		// Both slots are required for cross-fade; bail if PHP didn't render them
		if ( ! slots[ 0 ] || ! slots[ 1 ] ) return;

		// slots[0] starts as active (populated by PHP), slots[1] starts hidden
		let activeSlot = slots[ 0 ];
		let inactiveSlot = slots[ 1 ];

		const reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
		let isTransitioning = false;

		function swapContent( slot, step ) {
			slot.innerHTML = '';

			const headerEl = document.createElement( 'div' );
			headerEl.className = 'workflow-section__step-header';
			if ( step.logoUrl ) {
				const logoEl = document.createElement( 'img' );
				logoEl.className = 'workflow-section__step-logo';
				logoEl.src = step.logoUrl;
				logoEl.alt = '';
				headerEl.appendChild( logoEl );
			}
			const numEl = document.createElement( 'span' );
			numEl.className = 'workflow-section__step-num';
			numEl.textContent = step.number;
			headerEl.appendChild( numEl );
			slot.appendChild( headerEl );

			const bodyEl = document.createElement( 'div' );
			bodyEl.className = 'workflow-section__step-body';

			if ( step.iconUrl ) {
				const iconEl = document.createElement( 'img' );
				iconEl.className = 'workflow-section__step-icon';
				iconEl.src = step.iconUrl;
				iconEl.alt = '';
				bodyEl.appendChild( iconEl );
			}

			const titleEl = document.createElement( 'h3' );
			titleEl.className = 'workflow-section__step-title';
			titleEl.textContent = step.title;
			bodyEl.appendChild( titleEl );

			if ( step.description ) {
				const descEl = document.createElement( 'p' );
				descEl.className = 'workflow-section__step-desc';
				descEl.textContent = step.description;
				bodyEl.appendChild( descEl );
			}

			slot.appendChild( bodyEl );

			if ( step.ctaText ) {
				const ctaEl = document.createElement( 'a' );
				ctaEl.className = 'workflow-section__step-cta btn--primary';
				ctaEl.href = ( /^(https?:\/\/|\/|#)/.test( step.ctaUrl || '' ) ) ? step.ctaUrl : '#';
				const textSpan = document.createElement( 'span' );
				textSpan.className = 'btn--primary__text';
				textSpan.textContent = step.ctaText;
				const arrowSpan = document.createElement( 'span' );
				arrowSpan.className = 'btn--primary__arrow';
				arrowSpan.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none"><path d="M1 6.36401C0.447715 6.36401 4.82823e-08 6.81173 0 7.36401C-4.82823e-08 7.9163 0.447715 8.36401 1 8.36401L1 7.36401L1 6.36401ZM16.4212 8.07112C16.8117 7.6806 16.8117 7.04743 16.4212 6.65691L10.0572 0.292947C9.66668 -0.0975778 9.03351 -0.0975778 8.64299 0.292947C8.25246 0.683471 8.25246 1.31664 8.64299 1.70716L14.2998 7.36401L8.64299 13.0209C8.25246 13.4114 8.25246 14.0446 8.64299 14.4351C9.03351 14.8256 9.66668 14.8256 10.0572 14.4351L16.4212 8.07112ZM1 7.36401L1 8.36401L15.7141 8.36401L15.7141 7.36401L15.7141 6.36401L1 6.36401L1 7.36401Z" fill="white"/></svg>';
				ctaEl.appendChild( textSpan );
				ctaEl.appendChild( arrowSpan );
				slot.appendChild( ctaEl );
			}
		}

		function renderStep( index ) {
			const step = steps[ index ];
			if ( ! step ) return;
			if ( isTransitioning ) return; // ignore rapid clicks mid-transition

			indicators.forEach( ( ind, i ) => ind.classList.toggle( 'is-active', i === index ) );
			paginationDots.forEach( ( dot, i ) => dot.classList.toggle( 'is-active', i === index ) );

			activeIndex = index;
			if ( nextBtn ) nextBtn.setAttribute( 'aria-disabled', 'false' ); // always enabled — loops back to slide 1

			// Keep the prev button's accessible name in sync with its behavior:
			// on slide 0 it advances to slide 1, so announce it as "Next step".
			if ( prevBtn ) {
				const prevLabelEl = prevBtn.querySelector( '.visually-hidden' );
				if ( prevLabelEl ) {
					prevLabelEl.textContent = index === 0
						? ( prevBtn.dataset.labelWrap || prevLabelEl.textContent )
						: ( prevBtn.dataset.labelPrev || prevLabelEl.textContent );
				}
			}

			if ( reducedMotion ) {
				swapContent( activeSlot, step );
				return;
			}

			// Write new content into the hidden slot, then cross-fade
			isTransitioning = true;
			// Lock container height so position:relative→absolute swap doesn't flash white
			if ( detailEl ) detailEl.style.height = detailEl.offsetHeight + 'px';
			setTimeout( function () {
				if ( detailEl ) detailEl.style.height = '';
				isTransitioning = false;
			}, 350 );

			swapContent( inactiveSlot, step );
			inactiveSlot.removeAttribute( 'aria-hidden' );
			inactiveSlot.classList.add( 'is-active' );
			activeSlot.classList.remove( 'is-active' );
			activeSlot.setAttribute( 'aria-hidden', 'true' );

			// Swap references for next transition
			const prev = activeSlot;
			activeSlot = inactiveSlot;
			inactiveSlot = prev;
		}

		if ( prevBtn ) {
			prevBtn.addEventListener( 'click', () => {
				if ( activeIndex === 0 ) {
					// On first slide, prev acts as next
					if ( steps.length > 1 ) renderStep( 1 );
				} else {
					renderStep( activeIndex - 1 );
				}
			} );
		}

		if ( nextBtn ) {
			nextBtn.addEventListener( 'click', () => {
				if ( activeIndex < steps.length - 1 ) {
					renderStep( activeIndex + 1 );
				} else {
					renderStep( 0 ); // loop back to first slide
				}
			} );
		}

		indicators.forEach( ( btn ) => {
			btn.addEventListener( 'click', () => {
				const stepIndex = parseInt( btn.dataset.step, 10 );
				renderStep( stepIndex );
			} );
		} );

		paginationDots.forEach( ( dot, i ) => {
			dot.style.cursor = 'pointer';
			dot.addEventListener( 'click', () => renderStep( i ) );
		} );

		// Touch swipe support for mobile slider
		const navEl = section.querySelector( '.workflow-section__nav' );
		if ( navEl ) {
			let touchStartX = 0;
			let touchEndX = 0;
			const SWIPE_THRESHOLD = 50;

			navEl.addEventListener( 'touchstart', ( e ) => {
				touchStartX = e.changedTouches[ 0 ].screenX;
			}, { passive: true } );

			navEl.addEventListener( 'touchend', ( e ) => {
				touchEndX = e.changedTouches[ 0 ].screenX;
				const diff = touchStartX - touchEndX;
				if ( Math.abs( diff ) > SWIPE_THRESHOLD ) {
					if ( diff > 0 ) {
						// swipe left: next, loop to 0 on last
						renderStep( activeIndex < steps.length - 1 ? activeIndex + 1 : 0 );
					} else if ( diff < 0 && activeIndex > 0 ) {
						renderStep( activeIndex - 1 );
					}
				}
			}, { passive: true } );
		}

		renderStep( 0 );
	} );
} );
